module.exports = __webpack_public_path__ + "static/media/questioner-walk.f5a2eb50.gif";